import { Component, OnInit, signal } from '@angular/core'
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Router } from '@angular/router'
import { ProgressiveProfileService } from '../../common/api/services/progressive-profile.service'
import { WIRService } from '../../common/api/services/wir.service'
import { languageContent } from '../../common/json/sign-in-content'
import { ValidatorService } from '../../common/utilities/validator.service'
import { CognitoService } from '../../common/api/services/cognito.service'
import { CookieService } from 'ngx-cookie-service'
import { UserInputService } from '../../common/api/services/user-input.service'
import { GtmImplementation } from '../../common/api/services/gtmImplementation'
import { HeaderComponent } from '../../common/component/header/header.component';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.css'],
    imports: [HeaderComponent, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgClass]
})
export class SignInComponent implements OnInit {
  signInFormGroup: FormGroup
  questions: any
  submitted: boolean = false
  refreshToken: any
  counsellorCountry: any
  selectedLanguage: any = 'EN'
  welcomeHeading: any
  nextButton: any
  enterEmail: any
  counsellorCountryCode: any
  defaultLanguage = 'EN'
  includeHeader: boolean = false
  showLoader = signal(false)
  officeDetails: any

  constructor (
    public formBuilder: FormBuilder,
    private WIRService: WIRService,
    private progrssiveProfileService: ProgressiveProfileService,
    private route: Router,
    public validatorService: ValidatorService,
    public cognitoService: CognitoService,
    public cookieService: CookieService,
    public userInputService: UserInputService,
    public gtmImplementation: GtmImplementation
  ) {
    this.signInFormGroup = this.formBuilder.group({
      emailAddress: ['', [Validators.required, Validators.pattern(this.validatorService.isValidEmail())]]
    })
  }

  ngOnInit (): void {
    this.removeLocalStorage()
    this.showLoader.set(true)
    this.selectedLanguage = localStorage.getItem('languageSelected') ? localStorage.getItem('languageSelected') : 'EN'
    this.getSFDetails()
    this.getLanguageContent(this.selectedLanguage)
    sessionStorage.setItem('previousURL', 'signin')
  }

  get f (): any { return this.signInFormGroup.controls }

  removeLocalStorage (): any {
    sessionStorage.removeItem('previousURL')
    localStorage.removeItem('previousURL')
    localStorage.removeItem('userEmail')
    localStorage.removeItem('isExistingUser')
    this.userInputService.clearAll()
  }

  getSFDetails (): any {
    const sfResponse: any = localStorage.getItem('sfResponse')
    if (!sfResponse) {
      this.route?.navigateByUrl('/')
      return
    }
    this.officeDetails = JSON.parse(sfResponse)
    this.counsellorCountry = this.officeDetails?.wir_cognito_country
    this.counsellorCountryCode = this.officeDetails?.wir_country_code
    this.getProgressiveProfileQuestions(this.officeDetails?.wir_cognito_country, this.selectedLanguage)
  }

  nextpage (): any {
    this.submitted = true
    if (this.signInFormGroup.valid) {
      const email = this.signInFormGroup.value.emailAddress
      this.userInputService.setValue('primary_email', email)
      localStorage.setItem('userEmail', email)
      this.gtmImplementation.trackEvents('wir_enter_email', 'next_button', 'next', 'email_page', 'anonymous_user', 'na')
      this.route?.navigateByUrl('/signup')
    }
  }

  getProgressiveProfileQuestions (country: any, language: any): any {
    this.showLoader.set(true)
    this.includeHeader = true
    this.progrssiveProfileService.getProgressiveProgileQuestions(country, language).subscribe((ppQuestions: any) => {
      this.showLoader.set(false)
      this.progrssiveProfileService.ppQuestionsObject.next(ppQuestions)
      this.progrssiveProfileService.serviceQuestions = ppQuestions
      this.questions = ppQuestions.items[0].fields.questions
      this.gtmImplementation.pageView('email_page', 'anonymous_user', 'na')
    }, (error: any) => {
      console.log(error)
      this.showLoader.set(false)
      this.route?.navigateByUrl('/error')
    })
  }

  getLanguageContent (language: any): any {
    if (language === this.defaultLanguage) {
      this.welcomeHeading = languageContent[language]?.headingValue
      this.nextButton = languageContent[language]?.buttonValue
      this.enterEmail = languageContent[language]?.enterEmail
    } else {
      this.welcomeHeading = languageContent[this.counsellorCountryCode + '_' + language]?.headingValue
      this.nextButton = languageContent[this.counsellorCountryCode + '_' + language]?.buttonValue
      this.enterEmail = languageContent[this.counsellorCountryCode + '_' + language]?.enterEmail
    }
  }
}
